import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space, Text } from '@redlink/components/atoms';
import { MoreButton } from '@redlink/components/molecules';

export const PreviewListContainer = memo(
  ({ style, onPress, children, title }) => {
    const { styles } = useStyle();
    return (
      <View style={[styles.container, style]}>
        <View style={styles.headerContainer}>
          <Text style={styles.title}>{title}</Text>
          <MoreButton onPress={onPress} />
        </View>
        <Space size={8} />
        {children}
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, shadow, contentWidth, size }) => ({
  container: {},
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
  },
  title: {
    fontSize: 14,
    flex: 1,
    color: colors.title,
    fontWeight: 'bold',
  },
}));
